import Icon from '@material-ui/icons/CastForEducation';
import Edit from './SetTrainingEdit'
import List from './SetTrainingList'
import Create from './SetTrainingCreate'
import Show from './SetTrainingShow'

export default {
    list: List,
    edit: Edit,
    icon: Icon,
    create: Create,
    show: Show
};
